import { useQuery } from '@tanstack/react-query';

// common
import { KEYS_QUERY } from 'common/constants';
import useService from 'common/hook/useService';
import { handleException } from 'modules/account/detail/helpers/utils';

// screen
import type { MenuDishStatisticsResponse } from 'modules/dashboard/types';

interface Props {
  customerOperationCode?: string;
  monthKey?: string;
  enabled?: boolean;
}

/**
 * Lấy số liệu thống kê món trên thực đơn cho (khách hàng, tháng) — dữ liệu do MenuPlan đẩy sang (API B1).
 * Chưa có dữ liệu → backend trả has_data=false (không phải lỗi).
 */
const useMenuDishStatistics = ({ customerOperationCode, monthKey, enabled = true }: Props) => {
  const service = useService();

  return useQuery({
    queryKey: [KEYS_QUERY.menuDishDashboard, customerOperationCode, monthKey],
    queryFn: async (): Promise<MenuDishStatisticsResponse | null> => {
      try {
        // customerOperationCode có thể rỗng: không chọn khách vẫn lấy pie chart (global)
        // + NCC/HSNL toàn hệ thống. Chỉ monthKey là bắt buộc.
        if (!service || !monthKey) return null;
        return await service.DashboardController_getMenuDishStatistics({
          queries: { customer_operation_code: customerOperationCode ?? '', month_key: monthKey },
        });
      } catch (error) {
        handleException(error);
        return null;
      }
    },
    enabled: !!service && !!monthKey && enabled,
  });
};

export default useMenuDishStatistics;
